/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_ClearInputs */

const en_landing_studio_clear = /** @type {(inputs: Landing_Studio_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const zh_landing_studio_clear = /** @type {(inputs: Landing_Studio_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清空`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Landing_Studio_ClearInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_clear = /** @type {((inputs?: Landing_Studio_ClearInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_ClearInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_clear(inputs)
	return zh_landing_studio_clear(inputs)
});
export { landing_studio_clear as "landing.studio.clear" }